<template>
<div class="nj-input-check">
    <div class="nj-label">{{ label }}</div>
    <div class="nj-input-check--container">
        <input type="checkbox"
            :disabled="disabled"
            :checked="value"
            @input="input($event)" />
        <span>{{ text }}</span>
    </div>
</div>
</template>
<script>
export default {
    name: "InputCheck",
    props: {
        value: null,
        label: {    
            type: String,
            default: "_",
        },
        text: {
            type: String,
            default: "",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Array,
            default: null,
        },
    },
    watch: {
        value(newValue) {
            if (newValue != null && this.options != null && this.options.length != 0) {
                const index = this.options.findIndex((item) => item == newValue)
                this.$emit("input", this.options[index])
            }
        },
    },
    methods: {
        input(event) {
            const result = event.target.checked
            if (this.options != null && this.options.length != 0) {
                if (result) {
                    this.$emit("input", this.options[0])
                }
                else {
                    this.$emit("input", this.options[1])
                }
            }
            else {
                this.$emit("input", result)
            }
        },
    },
    mounted() { },
}
</script>

<style scoped>
.nj-input-check {}

.nj-input-check--container {
    display: flex;
    gap: 4px;

}

.nj-input-check--container>input[type='checkbox'] {
    cursor: pointer;
}
</style>